import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    Output,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { hasValidator } from '../_helpers/functions';

type HTMLInputTypeAttribute =
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'reset'
    | 'search'
    | 'submit'
    | 'tel'
    | 'text'
    | 'time'
    | 'url'
    | 'week';

@Component({
    selector: 'sume-input',
    templateUrl: './field.component.html',
})
export class FieldComponent implements AfterViewInit {
    @Input() customFeedbackMessage: string;
    @Input() dropSpecialCharacters = true;
    @Input() type: HTMLInputTypeAttribute;
    @Input() currency: boolean;
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() messages: any;
    @Input() changeText = false;
    @Input() range = [0];
    @Input() step: number;
    @Input() mask;
    @Input() placeholder = '';
    @Input() helpMessage: string;
    @Output() current: any;
    isRequired = false;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        this.isRequired = hasValidator(
            this.formGroup.controls[this.controlName],
            'required'
        );
        this.cdr.detectChanges();
    }

    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }
}
